import { Node } from "@p0security/shared/graph/types";
import { ProviderOrAll } from "@p0security/shared/types/assessment";
import {
  AssessmentNodes,
  AssessmentSchema,
  AssessmentSchemaAttribute,
} from "@p0security/shared/types/assessment/data/index";
import { Dictionary } from "lodash";

import { Properties } from "../../../Properties.tsx";

export const NodeProperties: React.FC<{
  node: Node<AssessmentNodes, keyof AssessmentNodes>;
  provider: ProviderOrAll;
}> = ({ node, provider }) => {
  const { key, data, type } = node;

  const schema: Dictionary<AssessmentSchemaAttribute> =
    AssessmentSchema[type].attributes;
  const value = data ? { ...data, key } : undefined;

  return (
    <Properties labelKey={provider} value={value} schema={schema} showKeys />
  );
};
